




























































































import { Prop, Component, Vue, Watch, Emit } from 'vue-property-decorator';
import {
  FormItem,
  RadioButton,
  RadioGroup
} from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
import ParcelsList from '@/components/inquiry/new/CargoList.vue';
import ContainersList from '@/components/inquiry/new/ContainerList.vue';
import {
  CargoDescriptionFields,
  CargoDescriptionInput,
  ParcelFields,
  ParcelInput,
  RequestedContainerInput,
  TransportationTypeEnum,
  CargoDescriptionFields_parcels,
  CargoTypeEnum
} from '@/types/graphql/schemaTypes';
// rules
import rules from '@/rules/rules';

@Component({
  components: {
    ParcelsList,
    ContainersList,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'nullable-number-input': NullableNumberInput,
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup
  }
})
export default class CargoDescription extends Vue {
  @Prop() public cargoDescription!: CargoDescriptionFields;
  @Prop({ required: true, type: String }) public transportationType!: TransportationTypeEnum;
  @Prop({ required: true, type: String }) public cargoType!: CargoTypeEnum;
  @Prop({ default: false }) readOnly!: boolean;

  private emptyParcels: ParcelInput[] = [{
    description: null,
    length: null,
    width: null,
    height: null,
    netWeight: null,
    packagingType: 'BX',
    quantity: 1, // quantity of box -> (if packaging) or item -> (if no packaging)
    productQuantity: null // number of product in box
  }];

  private emptyContainers: RequestedContainerInput[] = [{
    contentNetWeight: null,
    requestedContainerCount: null,
    requestedContainerType: null
  }];

  private parcels: ParcelInput[] = [...this.emptyParcels];
  private parcelsWithProduct: ParcelInput[] = [...this.emptyParcels];

  // FIXME: types
  public editedDescription: CargoDescriptionInput = {
    totalVolume: Math.round((this.cargoDescription.totalVolume || 0) * 1000) / 1000 || null,
    totalWeight: Math.round((this.cargoDescription.totalWeight || 0) * 1000) / 1000 || null,
    description: null
  };

  private rules = rules;
  private totals = {
    volume: 0,
    weight: 0
  };

  get cargoTypeMode(): CargoTypeEnum {
    return this.cargoType;
  }

  set cargoTypeMode(cargoType: CargoTypeEnum) {
    this.changeCargoType(cargoType);
    this.$emit('changeCargoType', cargoType);
  }

  get displayCargoTypeSwitch() {
    return this.transportationType !== TransportationTypeEnum.air && !this.readOnly;
  }

  get displayButtons() {
    return this.cargoTypeMode !== CargoTypeEnum.FCL && !this.readOnly;
  }

  created() {
    this.resetData();
  }

  private calculateTotals(parcles: ParcelInput[]) {
    // resert values
    this.totals = {
      volume: 0,
      weight: 0
    };
    parcles.forEach((parcel: any) => {
      this.totals.volume += Math.round(
        (((parcel.length || 0) *
        (parcel.width || 0) *
        (parcel.height || 0) *
        (parcel.quantity || 1)) *
        1000) / 1000) /
        1000000;
      this.totals.weight += (parcel.netWeight || 0) * (parcel.quantity || 1);
    });
  }

  private customMeasurments() {
    const customVolume = this.editedDescription.totalVolume !== this.totals.volume;
    const customWeigth = this.editedDescription.totalWeight !== this.totals.weight;

    return {
      totalVolume: (customVolume) ? this.editedDescription.totalVolume : null,
      totalWeight: (customWeigth) ? this.editedDescription.totalWeight : null
    };
  }

  @Watch('readOnly')
  private resetData() {
    const parcels: ParcelFields[] = this.cargoDescription.parcels || [];
    this.editedDescription.description = this.cargoDescription.description;
    this.changeCargoType(this.cargoTypeMode);
  }

  updateContainers(containers: RequestedContainerInput[]) {
    this.editedDescription.containers = containers;

    this.$emit('changeDescription', {
      containers,
      description: this.editedDescription.description
    });
  }

  updateParcels(parcels: ParcelInput[]) {
    this.parcels = parcels;
    this.calculateTotals(parcels);
    this.$emit('changeDescription', {
      parcels,
      description: this.editedDescription.description,
      ...this.customMeasurments()
    });
  }

  updateProductParcels(parcels: ParcelInput[]) {
    this.parcelsWithProduct = parcels;
    this.calculateTotals(parcels);
    this.$emit('changeDescription', {
      parcels,
      description: '',
      ...this.customMeasurments()
    });
  }

  @Watch('editedDescription', { deep: true })
  public changeDescription() {
    this.changeCargoType(this.cargoTypeMode);
  }

  @Watch('cargoType')
  public changeCargoType(value: CargoTypeEnum) {
    if (value === CargoTypeEnum.FCL) {
      this.updateContainers(this.editedDescription.containers || [...this.emptyContainers]);
    } else {
      this.updateParcels(this.parcels || [...this.emptyParcels]);
    }
  }
}
